/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import financingIcon from '../../../../public/assets/staticIcon/financingIcon.svg';
import auctionCancellation from '../../../../public/assets/staticIcon/auctionCancellation.svg';
import cashOnly from '../../../../public/assets/staticIcon/cashOnly.svg';
import inpersonIcon from '../../../../public/assets/staticIcon/inpersonIcon.svg';
import inspection from '../../../../public/assets/staticIcon/inspection.svg';
import isOccupied from '../../../../public/assets/staticIcon/isOccupied.svg';
import noBuyersPremium from '../../../../public/assets/staticIcon/noBuyersPremium.svg';
import noInspection from '../../../../public/assets/staticIcon/noInspection.svg';
import onlineBidding from '../../../../public/assets/staticIcon/onlineBidding.svg';
import specialServicing from '../../../../public/assets/staticIcon/specialServicing.svg';
import inPersonBidding from '../../../../public/assets/images/inPersonBidding.png'
import mayNotBeAvailable from '../../../../public/assets/images/mayNotBeAvailable.png'
import EyeOrange from '../../../../public/assets/images/EyeOrange.png'
import { Modal, Button, Row, Col } from "react-bootstrap";

// import { ActivityIndicator, TouchableOpacity } from 'react-native';
// import styled from 'styled-components/native';
// import _ from 'lodash';

// import { Icons } from 'src/assets';

// import { useSelector } from 'react-redux';
// import { replaceDateWord } from '../../utils/pdpUtils';

// const FeatureContainer = styled.View`
//   margin-top: 10px;
//   flex: 1;
// `;

// const img = styled.Image.attrs(props => ({
//   resizeMode: 'contain',
// }))`
//   width: 40px;
//   height: 40px;
//   margin-right: 12px;
// `;

const FeaturesSection = ({
  data,
  commonAttributes,
  financialType,
  invrAprvlReqdProp,
  isFcOnlineFlag,
  fcProxyBidEnabled,
  isForeclosure,
  isPreview,
  listingType,
  inspectionData,
  isCAFCSaleProperty,
}) => {
  const propertyCompleteDetails = useSelector(state => state.pdp?.pdpInitData);

   const countyBiddingEnabled =
    propertyCompleteDetails?.countyBiddingEnabled === 'N' ? false : true;


  const isCWCOTFirstLookProgram =
    propertyCompleteDetails?.propertyDetails?.commonAttributes?.propCategory ===
    'SC' &&
    propertyCompleteDetails?.propertyDetails?.cwcotUpdatesEnabled &&
    propertyCompleteDetails?.propertyDetails?.cwcotUpdatesValid;

  const firstLookDate =
    propertyCompleteDetails?.propertyDetails?.firstLookCwcotEndDate;

  if (data && data.pdpStaticContent && commonAttributes) {
    const propCategory = commonAttributes.propCategory;

    const isFirstLookCMSContent =
      data?.pdpStaticContent[[propCategory]]?.conditionBased?.firstLook;

    // Identify the clickable phrase
    const highlightText = 'HUD-approved nonprofit';
    // Split text into parts
    const firstLookCMSParts = isFirstLookCMSContent?.staticContentBody?.split(
      highlightText,
    );

    const isShortSale = propCategory === 'SHRT_SALE';
    const isCommercial = propCategory === 'COMMERCIAL';
    const { status } = commonAttributes;


    const isOccupied =
      commonAttributes?.isOccupied &&
      data?.pdpStaticContent[[propCategory]]?.conditionBased?.isOccupied
        ?.staticContentHead;
    // const inspectionContigency =
    //   commonAttributes.isOccupied === false &&
    //   data.pdpStaticContent[[propCategory]]?.conditionBased /* Earlier it was coming from cms but now it is coming from api call. */
    //     ?.inspectionContigency?.staticContentHead;
    const inspect =
      commonAttributes?.isOccupied === false &&
      !isPreview &&
      (inspectionData[0]?.description && inspectionData[0]?.title);
    const isCashOnly =
      financialType && financialType.length === 1 && financialType[0] === 'CASH';



    let isSeller =
      propertyCompleteDetails?.propertySpecialDetails?.pdpEnabledFeatures &&
      propertyCompleteDetails?.propertySpecialDetails?.pdpEnabledFeatures?.indexOf('SELLER') !== -1;


    //  const isNoBuyerPremium = pdpInitData?.listingDetail?.isNoBuyerPremium === true ? true : false

    const isNoBuyerPremium = isSeller && propertyCompleteDetails?.propertySpecialDetails?.listingType !== 'TRNL';

    // const isNoBuyerPremium =
    //   financialType.length === 1 &&
    //   (financialType.includes('CASH') ||
    //     financialType.includes('MORTGAGE')) &&
    //   data?.pdpStaticContent[[propCategory]]?.conditionBased?.noBuyersPremium
    //     ?.staticContentHead;

    const isSpecialServicing = invrAprvlReqdProp;
    const isMayNotBeAvailable = propCategory === 'FORECLOSURE';
    const isInPersonBidding = propCategory === 'FORECLOSURE';
    const isForeclosureProperty = isForeclosure;

    const replaceDateWord = (content, date) => {
      if (typeof content !== 'string' || !content) return '';
      if (!date) return content;

      try {
        let formattedDate = '';

        if (!isNaN(date) && date.toString().length === 13) {
          const dateObj = new Date(Number(date));
          formattedDate = dateObj.toLocaleDateString();
        } else if (typeof date === 'string' && !isNaN(new Date(date))) {
          const dateObj = new Date(date);
          formattedDate = dateObj.toLocaleDateString();
        } else {
          formattedDate = date;
        }

        // Wrap the date in bold tags
        const boldDate = `<strong>${formattedDate}</strong>`;

        const datePlaceholders = ['##DATE##', '#DATE#', 'DATE'];
        let result = content;

        datePlaceholders.forEach(placeholder => {
          const regex = new RegExp(placeholder, 'g');
          result = result.replace(regex, boldDate);
        });

        return result;
      } catch (error) {
        return content;
      }
    };


    const handleHUDRedirection = () => {

    }

    // data.pdpStaticContent[[propCategory]].staticContent.staticContent2
    //   .excludeStates;
    const isFinancing =
      financialType && (
        (financialType.length === 1 && financialType.includes('MORTGAGE')) ||
        (financialType.length === 2 &&
          financialType.includes('MORTGAGE') &&
          financialType.includes('CASH') &&
          data?.pdpStaticContent[[propCategory]]?.conditionBased?.mortgage
            ?.staticContentHead)
      );
    const isFcOnlineProp =
      isFcOnlineFlag !== 'undefined' && isFcOnlineFlag === 'Y' ? true : false;

    const shouldShowCashOnly = (status === 'SPND' || status === 'SLD') ? false : true
    return (
      <div className=''>
        {isForeclosureProperty && isCAFCSaleProperty && (
          <Row className=" left_side_widget ml0 mr0 pt20 pb10" style={{marginLeft:0 , marginRight:0}}>
            <div className="col-lg-2 pl0 pr0">
              <img src={inPersonBidding} alt='spl' />
            </div>
            <div className="col-lg-10">
              <div>
                <h4 className="featureTitle">Right to Bid Post-Auction</h4>

                <p className="featureDescription">
                  Under a California law that went into effect on January 1, 2021, in certain circumstances, persons defined under the law as "Eligible Bidders" have the opportunity to submit a bid to the trustee within fifteen days following the auction event (also called the "sale date") for consideration before the foreclosure sale is finalized. Please contact the trustee with any questions regarding the post-sale or the bidding process.
                </p>
              </div>
            </div>
          </Row>
        )}
        {isCWCOTFirstLookProgram && isFirstLookCMSContent && (
          <Row className="   left_side_widget ml0 mr0 pt20 pb10 " style={{marginLeft:0 , marginRight:0}}>
            <div className="col-2 pl0 pr0">
              <img  height={48} width={48} src={EyeOrange} alt="auction" />
            </div>
            <div className="col-10">
              <div>
                <h4 className="featureTitle">
                  {isFirstLookCMSContent?.staticContentHead}
                </h4>

                {/* Render Dynamic Text with Highlighted Clickable Part */}
                <p className="featureDescription">
                  {firstLookCMSParts && firstLookCMSParts[0]}{' '}
                  {/* First part of the text */}
                  <a className="link" style={{ color: '#118BF4' }} target="_blank" href={isFirstLookCMSContent.redirectionLink}>


                    {firstLookCMSParts && highlightText}

                  </a>
                  {firstLookCMSParts && firstLookCMSParts[1]}{' '}
                  {/* Second part of the text */}
                </p>



                {/* <p className="featureDescription">
                  {replaceDateWord(
                    isFirstLookCMSContent?.staticContentFooter,
                    firstLookDate,
                  )}
                </p> */}

                <div className="featureDescription" dangerouslySetInnerHTML={{
                  __html: replaceDateWord(
                    isFirstLookCMSContent?.staticContentFooter,
                    firstLookDate
                  )
                }} />

              </div>
            </div>
          </Row>
        )}

        {isForeclosureProperty && fcProxyBidEnabled && (
          <Row className=" left_side_widget ml0 mr0 pt20 pb10 " style={{marginLeft:0 , marginRight:0}}>
            <div className="col-2 pl0 pr0">
              <img src={auctionCancellation} alt='auction' />
              {/* <img source={Icons.ProxyBid} /> */}
            </div>
            <div className="col-10">
              <div>
                <h4 className="featureTitle">
                  {
                    //data.pdpStaticContent[[propCategory]]?.staticContent?.staticContent1?.staticContentHead
                    data?.pdpStaticContent[[propCategory]]?.conditionBased
                      ?.proxyBid?.staticContentHead
                  }
                </h4>
                {/*  <p className="featureDescription"> size={12} lh={16}>
                {
                  data.pdpStaticContent[[propCategory]]?.staticContent
                    ?.staticContent1?.excludeStates
                }
              </p> */}
                <p className="featureDescription">
                  {
                    //data.pdpStaticContent[[propCategory]]?.staticContent
                    //?.staticContent1?.staticContentBody
                    data?.pdpStaticContent[[propCategory]]?.conditionBased
                      ?.proxyBid?.staticContentBody
                  }
                </p>
              </div>
            </div>
          </Row>
        )}
        {isForeclosureProperty && isFcOnlineProp && (
          <Row className=" left_side_widget ml0 mr0 pt20 pb10 " style={{marginLeft:0 , marginRight:0}}>
            <div className="col-2 pl0 pr0">
              <img height={48} width={48} src={noInspection} alt='inspection' />
              {/* <img source={Icons.Inspection} /> */}
            </div>
            <div className="col-10">
              <div>
                <h4 className="featureTitle">
                  {
                    //data.pdpStaticContent[[propCategory]]?.staticContent?.staticContent1?.staticContentHead
                    data?.pdpStaticContent[[propCategory]]?.preConditionBased
                      ?.fcOnline?.staticContentHead
                  }
                </h4>
                {/*  <p className="featureDescription"> size={12} lh={16}>
                {
                  data.pdpStaticContent[[propCategory]]?.staticContent
                    ?.staticContent1?.excludeStates
                }
              </p> */}
                <p className="featureDescription">
                  {
                    //data.pdpStaticContent[[propCategory]]?.staticContent
                    //?.staticContent1?.staticContentBody
                    data?.pdpStaticContent[[propCategory]]?.preConditionBased
                      ?.fcOnline?.staticContentBody
                  }
                </p>
              </div>
            </div>
          </Row>
        )}

        {inspect && !isForeclosureProperty && (
          <Row className=" left_side_widget ml0 mr0 pt20 pb10  " style={{marginLeft:0 , marginRight:0}}>
            <div className="col-2 pl0 pr0">
              <img height={48} width={48}  src={inspection} alt='inspection' />
              {/* <img source={Icons.InspectionContigency} /> */}
            </div>
            <div className="col-10">
              <div>
                <h4 className="featureTitle">
                  {inspectionData[0]?.title}
                </h4>
                <p className="featureDescription">

                  {inspectionData[0]?.description}
                </p>
              </div>
            </div>
          </Row>
        )}

        {(isForeclosureProperty || isCashOnly) && (
          <Row className=" left_side_widget ml0 mr0 pt20 pb10  " style={{marginLeft:0 , marginRight:0}}>
            <div className="col-2 pl0 pr0">
              <img height={48} width={48}  src={cashOnly} alt='cashonly' />
            </div>
            <div className="col-10">
              <div>
                {isForeclosureProperty ? (
                  <h4 className="featureTitle">
                    {
                      data.pdpStaticContent.REO.conditionBased.cashOnly
                        .staticContentHead
                    }

                  </h4>

                ) : (
                  <h4 className="featureTitle">
                    {data.pdpStaticContent[[propCategory]]?.conditionBased
                      ?.cashOnly?.staticContentHead
                      ? undefined
                      : 'Cash Only'}
                    {
                      data?.pdpStaticContent[[propCategory]]?.conditionBased
                        ?.cashOnly?.staticContentHead
                    }
                  </h4>
                )}
                <p className="featureDescription">
                  {
                    data?.pdpStaticContent[[propCategory]]?.conditionBased?.cashOnly
                      ?.staticContentBody ? undefined : "Financing not available"
                  }
                  {
                    data?.pdpStaticContent[[propCategory]]?.conditionBased?.cashOnly
                      ?.staticContentBody
                  }
                </p>
              </div>
            </div>
          </Row>
        )}
        {(isNoBuyerPremium) && (
          <Row className=" left_side_widget ml0 mr0 pt20 pb10  " style={{marginLeft:0 , marginRight:0}}>
            <div className="col-2 pl0 pr0 pl0 pr0">
              <img height={48} width={48}  src={noBuyersPremium} alt='nbp' />

              {/* <img source={Icons.NoPremium} /> */}
            </div>
            <div className="col-10">
              <div>
                <h4 className="featureTitle">
                  {
                    data?.pdpStaticContent[[propCategory]]?.conditionBased
                      ?.noBuyersPremium?.staticContentHead
                  }
                </h4>
                <p className="featureDescription">

                  {
                    data.pdpStaticContent[[propCategory]]?.conditionBased?.noBuyersPremium
                      ?.staticContentBody
                  }
                </p>
              </div>
            </div>
          </Row>
        )}
        {isSpecialServicing &&
           propertyCompleteDetails?.propertySpecialDetails?.shortSaleFlag !== "Y" &&
          
          // (listingType === 'AUCN') && (
            <Row className=" left_side_widget ml0 mr0 pt20 pb10 " style={{marginLeft:0 , marginRight:0}}>
              <div className="col-2 pl0 pr0">
                <img height={48} width={48}  src={specialServicing} alt='splServicing' />
              </div>
              <div className="col-10">
                <div>
                  <div nobottommargin>
                    <h4 className="featureTitle">
                      {data.specialServicing.staticContentHead}
                    </h4>
                  </div>
                  <p className="featureDescription">
                    {data.specialServicing.staticContentBody}
                  </p>
                </div>
              </div>
            </Row>
          // )
          }

        {isFinancing && (
          <Row className=" left_side_widget ml0 mr0 pt20 pb10  " style={{marginLeft:0 , marginRight:0}}>
            <div className="col-2 pl0 pr0" tabIndex="0">
              <img  height={48} width={48}  src={financingIcon} alt='financingIcon' />
            </div>
            <div className="col-10">
              <h4 className="featureTitle" tabIndex="0">
                {
                  data?.pdpStaticContent[[propCategory]]?.conditionBased
                    ?.mortgage?.staticContentHead
                }
              </h4>
              <p className="featureDescription" tabIndex="0">
                {
                  data.pdpStaticContent.REO.conditionBased.mortgage
                    .staticContentBody
                }
              </p>
            </div>
          </Row>

        )}
        {isMayNotBeAvailable && (
          <Row className=" left_side_widget ml0 mr0 pt20 pb10  " style={{marginLeft:0 , marginRight:0}}>
            <div className="col-2 pl0 pr0">
              <img height={48} width={48}  src={mayNotBeAvailable} alt='splServicing' />

              {/* <img source={Icons.Available} /> */}
            </div>
            <div className="col-10">
              <div>
                {/* <div nobottommargin> */}
                <h4 className="featureTitle">
                  {
                    data?.pdpStaticContent[[propCategory]]?.staticContent
                      ?.staticContent2?.staticContentHead
                  }
                </h4>
                {/* </div> */}
                {/*  <p className="featureDescription"> size={12} lh={16}>
                {
                  data.pdpStaticContent[[propCategory]]?.staticContent
                    ?.staticContent2?.excludeStates
                }
              </p> */}
                <p className="featureDescription">
                  {
                    data?.pdpStaticContent[[propCategory]]?.staticContent
                      ?.staticContent2?.staticContentBody
                  }
                </p>
              </div>
            </div>
          </Row>
        )}
        {isForeclosureProperty && !isFcOnlineProp && !countyBiddingEnabled && (
          <Row className=" left_side_widget ml0 mr0 pt20 pb10  " style={{marginLeft:0 , marginRight:0}}>
            <div className="col-2 pl0 pr0">
              <img height={48} width={48}  src={inPersonBidding} alt='spl' />
              {/* <img source={Icons.InPerson} /> */}
            </div>
            <div className="col-10">
              <div>
                <h4 className="featureTitle">
                  {
                    //data.pdpStaticContent[[propCategory]]?.staticContent?.staticContent1?.staticContentHead
                    data?.pdpStaticContent[[propCategory]]?.conditionBased
                      ?.fcInperson?.staticContentHead
                  }
                </h4>
                {/*  <p className="featureDescription"> size={12} lh={16}>
                {
                  data.pdpStaticContent[[propCategory]]?.staticContent
                    ?.staticContent1?.excludeStates
                }
              </p> */}
                <p className="featureDescription">
                  {
                    //data.pdpStaticContent[[propCategory]]?.staticContent
                    //?.staticContent1?.staticContentBody
                    data?.pdpStaticContent[[propCategory]]?.conditionBased
                      ?.fcInperson?.staticContentBody
                  }
                </p>
              </div>
            </div>
          </Row>
        )}
        {isForeclosureProperty && isFcOnlineProp && (
          <Row className=" left_side_widget ml0 mr0 pt20 pb10  " style={{marginLeft:0 , marginRight:0}}>
            <div className="col-2 pl0 pr0">
              <img height={48} width={48}  src={onlineBidding} alt='onlineBidding' />
            </div>
            <div className="col-10">
              <div>
                <h4 className="featureTitle">
                  {
                    //data.pdpStaticContent[[propCategory]]?.staticContent?.staticContent1?.staticContentHead
                    data?.pdpStaticContent[[propCategory]]?.conditionBased
                      ?.fcOnline?.staticContentHead
                  }
                </h4>
                {/*  <p className="featureDescription"> size={12} lh={16}>
                {
                  data.pdpStaticContent[[propCategory]]?.staticContent
                    ?.staticContent1?.excludeStates
                }
              </p> */}
                <p className="featureDescription">
                  {
                    //data.pdpStaticContent[[propCategory]]?.staticContent
                    //?.staticContent1?.staticContentBody
                    data?.pdpStaticContent[[propCategory]]?.conditionBased
                      ?.fcOnline?.staticContentBody
                  }
                </p>
              </div>
            </div>
          </Row>
        )}
      </div>
    );
  }
  {
    /*return <ActivityIndicator size="large" color="#0000ff" />;*/
  }
  return null;
};

export default FeaturesSection;
